<script lang="ts" setup>
import { CustomerFlow } from '../new-desktop/core/models';
import {
  CustomerOriginQueryParamValue,
  TripPlannerPage,
} from '../new-desktop/core/models/navigation';
import type { TripPlannerQueryParams } from '../new-desktop/core/models/navigation';
import {
  usePaxStore,
  useCustomerFlowStore,
  useRecipeStore,
  useRouterStore,
  useQueryParamsStore,
} from '../new-desktop/core/stores';
import { useAccommodationUpsellStore } from '../new-desktop/pages/tripOverview/stores/upsell/accommodationUpsellStore';

import TripPlanner from './TripPlanner.vue';

const props = defineProps<TripPlannerQueryParams>();

const paxStore = usePaxStore();
const recipeStore = useRecipeStore();
const routerStore = useRouterStore();

const isCarTrip =
  routerStore.getCurrentTripPlannerView() === TripPlannerPage.CarTrip;

recipeStore.initializeProps({
  recipe: props.initialIngredients,
  preferredDay: props.initialSelectedDate,
  preferredMonth: props.initialSelectedMonth,
  itinerarySuggestionSortType: props.initialSuggestionSortType,
  returnTransport: props.returnTransport,
  metadata: props.metaData,
  searchForPackageRates: props.searchForPackageRates,
  isCarTrip,
});
paxStore.updatePax(props.initialPax);

const queryParamStore = useQueryParamsStore();
const customerFlowStore = useCustomerFlowStore();
const accommodationUpsellStore = useAccommodationUpsellStore();

queryParamStore.setQueryParams(props);

if (
  props.customerOrigin === CustomerOriginQueryParamValue.MarketplaceFlightSearch
) {
  customerFlowStore.setCustomerFlow(CustomerFlow.FlightOnlyFromMarketplace);
  const ownStayIngredient = recipeStore.ownStayOnlyRecipe[0];

  if (ownStayIngredient) {
    accommodationUpsellStore.loadSuggestions(ownStayIngredient.ingredientId);
  } else {
    throw new Error('Not supported flow! Expected ownStay ingredient!');
  }
}

if (props.customerOrigin === CustomerOriginQueryParamValue.InfiniteLoadReload) {
  customerFlowStore.setCustomerFlow(CustomerFlow.InfiniteLoadReload);
}

routerStore.setLandingRoute();
</script>

<template>
  <TripPlanner v-bind="props" />
</template>
